/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const InfoIcon = ({ color = '#222', backgroundColor = '#FFF', className = null }) => (
    <svg
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <circle fill={backgroundColor} cx="15" cy="15" r="15" />
        <path
            fill={color}
            d="M12.11,6.9c0-1.65,1.14-2.77,2.87-2.77s2.9,1.12,2.9,2.77-1.17,2.79-2.9,2.79-2.87-1.12-2.87-2.79ZM12.43,11.16h5.11v13.72h-5.11v-13.72Z"
        />
    </svg>
);

InfoIcon.propTypes = propTypes;

export default InfoIcon;
